import {isMobile} from "react-device-detect";

function AccessCourse({actualCourse, accessCourse, getEmailVerificationCode, accessErrorText}) {
    let styleWidth = {width: '30rem'};
    if (isMobile) {
        styleWidth = {width: '19rem'};
    }

    function submitForm(formData) {
        const rawAccessCode = formData.get("rawAccessCode");
        accessCourse(actualCourse, rawAccessCode);
    }

    let accessErrorMessage = "";
    if (accessErrorText !== "") {
        accessErrorMessage =
            <div className="d-flex justify-content-center">
                <div className="alert alert-secondary mt-3" role="alert" style={styleWidth}>
                    <i className="bi bi-exclamation-triangle"></i> {accessErrorText}
                </div>
            </div>;
    }

    return (
        <div>
            {accessErrorMessage}
            <div className="d-flex justify-content-center">
                <form action={submitForm} className="form-floating mt-3 mb-3" style={styleWidth}>
                    <div className="form-group mb-3">
                        <small className="form-text text-muted">Bitte geben Sie den Zugangscode zum Kurs an, der Ihnen von der Lehrperson mitgeteilt wurde.
                        </small>
                    </div>
                    <div className="form-floating mb-3">
                        <input name="rawAccessCode" type="password" className="form-control mb-3" id="accessCodeInput"
                               placeholder="Zugangscode zum Kurs"/>
                        <label htmlFor="accessCodeInput">Zugangscode des Kurses</label>
                    </div>
                        <button type="submit" className="btn btn-outline-primary" style={styleWidth}>
                            <i className="bi bi-arrow-right-circle"></i> Weiter
                        </button>
                </form>
            </div>
        </div>
    );
}

export default AccessCourse;